<template>
<div ref="PetBreedAdd">    
    <div class="TTL-el-form-search-regular">
        <span class="TTL-title">新增品种</span>
        <div class="TTL-button TTL-btn-option">
        <el-badge :value="breedlist.length > 1 ? breedlist.length : ''" class="item">
        <el-button @click="submitData">提交数据</el-button>
        </el-badge>
        </div>
        <div class="TTL-button TTL-btn-option" v-if="type=='add'">
        <el-button type="del" @click="clearAll">清空已填数据</el-button>
        </div>
        <div class="TTL-button TTL-btn-option" v-if="type=='add'">
        <el-button type="del" @click="addBreed">新增品种模板</el-button>
        </div>
    </div>
    
    <div>
        <div class="TTL-form-submit-box" v-for="(item,index) in breedlist" :key="index">
            <div class="TTL-form-submit-box-title">品种-{{index+1}}</div>
            <div class="TTL-button TTL-btn-option">
            <el-button type="del" v-if="index > 0" @click.stop="delbreed(index)">删除</el-button>
            </div>
            <el-form :inline="false">
                <el-form-item>
                    <label class="TTL-form-label">宠物品种图片</label>
                    <div class="TTL-image-box-large" @click.stop="uploadimages(index)">
                        <el-image :src="item.avar ? item.avar : require('@/assets/icon/pet-gray.png')" fit="cover" />
                        <span>（点击图片进行上传文件）</span>
                    </div>
                </el-form-item>
                <el-form-item>
                    <label class="TTL-form-label">宠物类型名称</label>
                    <div class="TTL-input width350 TTL-form-input">
                    <el-input v-model="item.breedname" placeholder="请输入宠物类型名称" clearable />
                    </div>
                </el-form-item>
            </el-form>
        </div>
    </div>
</div>
</template>

<script>
import INTERFACE_MODEL_PETS from '@/Interface/Pets/Pets';
import INTERFACE_MODEL_BASE from '@/Interface/index';
export default {
    components:{},
    data() {
        return {
            type:'add',
            file:'',             //图片变量，占位符
            addlimit: 10,        //单次新增限制
            uploadimageIndex:'', //获取当前上传图片的序号
            breedlist:[
                {breedname:'',avar:''}
            ],
        }
    },
    mounted() {
        this.OnloadMethod(); //页数初始化
    },
    methods: {

        /** 修改页面显示标签信息 **/
        ChangePageLabel() {
            
        },


        /** 页数初始化 **/
        OnloadMethod() {
            
        },

        /** 其它组件调用当前组件进行数据传递 **/
        BrotherComponentIn(data) {

        },


        /** 提交数据 **/
        submitData() {
            var checkresult=this.CheckDataBeforeSubmit();
            if(checkresult.error==1) {this.$notice({title:'提交数据提示',message:checkresult.message,type:'warning'});return false;}

            //调整提交数据
            var data=[];
            for(var i=0;i<this.breedlist.length;i++) data.push(this.breedlist[i]);
            data=JSON.stringify(data);

            var loadingobj=this.$refs.PetBreedAdd;
            this.$loading.openloading(loadingobj);  //加载等待动画

            INTERFACE_MODEL_PETS.ADD_PET_BREED({breeddata:data}).then((res) => {
                this.$loading.closeloading(loadingobj);
                if(res.status > 0) return false;
                this.resetParam(); //重置当前数据
                this.$notice({title:'成功提示',message:'数据提交成功',type:'success'});
            });
        },


        /** 数据提交前进行检测 **/
        CheckDataBeforeSubmit() {
            var result={error:0,message:''};
            if(this.breedlist.length==0) {result={error:1,message:'请添加品种信息'};return result;}

            //检测品种参数
            var breedname;
            var avar;
            for(var i=0;i < this.breedlist.length;i++) {
                breedname=this.breedlist[i].breedname;
                avar=this.breedlist[i].avar;
                if(!breedname || breedname=='') {result={error:1,message:'第'+(i+1)+'个品种名称不能为空'};return result;}
                if(!avar || avar=='') {result={error:1,message:'第'+(i+1)+'个品种图片不能为空'};return result;}
            }
            return result;
        },



        /** 清空当前数据 **/
        clearAll() {
            this.$confirm.confirm(
                '您是否确定要删除当前所有品种信息 ？',
                '删除提示',
                {confirmButtonText:'确定',cancelButtonText:'取消',type: 'warning'}
            ).then(()=> {
                this.resetParam(); //重置参数
            }).catch(()=> {

            });
        },


        /** 删除单个品种信息 **/
        delbreed(index) {
            this.breedlist.splice(index,1);
        },


        /** 新增品种模板信息 **/
        addBreed() {
            if(this.breedlist.length >= this.addlimit) {
                this.$notice({title:'消息提示',message:'单此添加品种请最多不要超过10个',type:'warning'});
                return false;
            }
            this.breedlist.push({breedname:'',avar:''});
        },


        /** 重置加载数据 **/
        resetParam() {
            this.breedlist=[{breedname:'',avar:''}];
        },


        /** 上传图片信息 **/
        uploadimages(index) {
            this.uploadimageIndex=index;                          //标记当前上传图片序号
            var obj=document.querySelector('#TTLFiles');          //获取文件对象
            obj.click();                                          //点击触发上传图片
            obj.addEventListener('change',this.uploadimagedata);  //添加监听事件
        },


        /** 上传图片信息操作 **/
        uploadimagedata(e) {
            var _this=this;
            this.file=e.target.files[0];       //获取上传的图片
            e.target.value=null;                //清空数据
            document.querySelector('#TTLFiles').removeEventListener('change',this.uploadimagedata);  //解除监听事件

            //上传图片到接口操作
            INTERFACE_MODEL_BASE.UPLOAD_FILES({imageType:'normal',File:this.file}).then((res) => {
                if(res.status > 0) return false;
                _this.breedlist[_this.uploadimageIndex].avar=_this.$ImageAddress+res.data.url;
            });
        },


    },
}
</script>
<style scoped>
.TTL-image-box-large {cursor: pointer;width:auto !important;}
.TTL-image-box-large .el-image {width:120px;height:120px;display: inline-block;border-radius: 5px;}
.TTL-image-box-large span {display: inline-block;font-size:12px;margin-left:20px;color:#f56c6c;}
.TTL-btn-option {display:inline-block;margin-right:20px;}
</style>